
import { computed, defineComponent, ref, SetupContext } from "vue";

export default defineComponent({
  name: "BaseSelect",
  props: {
    modelValue: {
      type: [String, Number],
      default: "",
    },
    options: {
      type: Array,
      required: true,
    },
    name: {
      type: String,
      default: "name",
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    optionName: {
      type: String,
      default: "name",
    },
    default: {
      type: String,
      required: false,
      default: null,
    },
    tabindex: {
      type: Number,
      required: false,
      default: 0,
    },
    label: {
      type: String,
      default: "",
    },
    errors: {
      type: Array,
      default: () => [],
    },
  },
  setup(props, { emit }: SetupContext) {
    const open = ref(false);
    const selected = ref(props.default ? props.default : props.options.length > 0 ? props.options[0] : null);

    const getErrors = computed(() => props.errors.filter((i: any) => i.type === props.name));

    const selectItem = (option: any) => {
      open.value = false;
      selected.value = option[props.optionName];
      emit("update:modelValue", option.id);
      emit("change");
    };

    const toggleSelect = () => {
      if (props.disabled) return;
      open.value = !open.value;
    };

    return {
      selected,
      open,
      selectItem,
      toggleSelect,
      getErrors,
    };
  },
  // mounted() {
  //   this.$emit("input", this.selected);
  // },
});
